import Spinner from 'components/Spinner';
import { useFetchNewSocialStats } from 'pages/headliner/useFetchNewSocialStats';
import React from 'react';
import MakeEmptyState from '../MakeEmptyState';
import { useHasAllPodcastsSocialShareInfo } from '../state';
import {
  PODCASTS_EMPTY_STATE_DESCRIPTION,
  PODCASTS_EMPTY_STATE_TITLE,
} from './constants';
import RssTableContainer from './RssTableContainer';

type HeadlinerVideosByRSSProps = {};

const HeadlinerVideosByRSS: React.FC<HeadlinerVideosByRSSProps> = () => {
  const { requestStatus } = useFetchNewSocialStats();
  const { data: hasData } = useHasAllPodcastsSocialShareInfo(requestStatus);

  if (hasData === undefined) return <Spinner />;

  if (hasData) return <RssTableContainer />;

  return (
    <MakeEmptyState
      page="Podcasts"
      title={PODCASTS_EMPTY_STATE_TITLE}
      description={PODCASTS_EMPTY_STATE_DESCRIPTION}
      cta="return to your audiograms"
    />
  );
};
export default HeadlinerVideosByRSS;
